import myAxios from "@/services/api";
import { API_GW_URL } from "@/config/api";

export default {
  async getForm(context) {
    try {
      let url = API_GW_URL + "/formless/getInitialFormByScopeID";
      const response = await myAxios.post(url, {
        app_token: context.getters.getUserSession.app_token,
        scopeID: context.getters.getReqID.scopeID,
        username: context.getters.getUserDetailList.usr_username,
      });

      if (response.data?.state !== "ok") {
        const errorMessage =
          response.data?.message ||
          "Falha no processo de obtenção do formulário. Verifique os dados inseridos.";
        throw new Error(errorMessage);
      }
      return response.data.data.data;
    } catch (error) {
      console.error("Erro de autenticação:", error.message || error);
      throw error;
    }
  },
};